<template>
  <td>
    <span v-if="newsType === 'CUSTOM'">-</span>
    <span v-else-if="value">{{$utils.timeText(value)}}</span>
    <span v-else style="color: #ea002c;">미확인</span>
  </td>
</template>

<script>
export default {
  props: {
    value: String,
    newsType: String
  }
}
</script>

<style>

</style>